/* eslint-disable camelcase */
const authTranslations = {
    en: {
        login: 'Sign in',
        logout: 'Sign out',
        userFetchError: 'Failed to fetch user data',
        tenantFetchError: 'Failed to fetch available tenants',
        tokenHintFetchError: 'Failed to initiate login',
        loginError: 'Login failed',
        loginError_AAD_Custom_Globus_IDP_Email_Mismatch: 'Your email address does not match the one used for your social account. Please log in with the email address suggested by the system.',
        dialog: {
            authFailed: {
                title: 'Authentication Failed',
                text: 'Please try logging in again.',
                close: 'Close'
            }
        },
        signInToGetFullAccess: {
            title: 'Please sign in to continue',
            description: 'Authenticate to update profile details, preferences, and get personalized matches.',
            button: 'Sign In to continue',
            consent: 'By continuing, you agree to the processing of your profile data.'
        },
        signInAccessPortal: {
            title: 'Sign In Required',
            description: 'To access the Career Portal, please sign in with your account.',
            button: 'Sign In',
            consent: 'Sign in if you already have a Globus.ai account. If you don\'t have one yet, use the link sent to you by your recruiter via SMS or email to access your portal directly. Can\'t find it? Use the options below.'
        },
        loginHelp: {
            divider: 'or',
            sendLink: {
                title: 'Lost your access link?',
                description: 'We can send you a quick access link to view your jobs and calendar.',
                emailLabel: 'Email',
                emailPlaceholder: 'Enter your email',
                button: 'Send Quick Access Link',
                success: 'Check your email for the link',
                errors: {
                    invalid_email: 'Please enter a valid email address',
                    candidate_not_found: 'No account found with this email',
                    send_failed: 'Unable to send email. Please try again later',
                    rate_limited: 'Too many requests. Please wait before trying again',
                    unknown: 'An error occurred. Please try again later'
                }
            },
            needHelp: {
                title: 'Contact Us',
                haveQuestion: 'Have a question?',
                contactUs: 'Contact us',
                questionLabel: 'Your question',
                questionPlaceholder: 'Describe your issue or question',
                button: 'Send question',
                success: 'Your question has been sent to our support team',
                errors: {
                    rate_limited: 'Please wait before sending another request',
                    unknown: 'Failed to send. Please try again'
                }
            }
        }
    },
    no: {
        login: 'Logg inn',
        logout: 'Logg ut',
        userFetchError: 'Kunne ikke hente brukerdata',
        tenantFetchError: 'Kunne ikke hente tilgjengelige leietakere',
        tokenHintFetchError: 'Kunne ikke starte innlogging',
        loginError: 'Innlogging feilet',
        loginError_AAD_Custom_Globus_IDP_Email_Mismatch: 'E-postadressen din samsvarer ikke med den som brukes for din sosiale konto. Vennligst logg inn med e-postadressen foreslått av systemet.',
        dialog: {
            authFailed: {
                title: 'Autentisering feilet',
                text: 'Vennligst prøv å logge inn igjen.',
                close: 'Lukk'
            }
        },
        signInToGetFullAccess: {
            title: 'Vennligst logg inn for å fortsette',
            description: 'Autentiser deg for å oppdatere profildetaljer, preferanser og få personlige treff.',
            button: 'Logg inn for å fortsette',
            consent: 'Ved å fortsette godtar du behandlingen av profildataene dine.'
        },
        signInAccessPortal: {
            title: 'Pålogging kreves',
            description: 'For å få tilgang til Karriereportalen, vennligst logg inn med kontoen din.',
            button: 'Logg inn',
            consent: 'Trenger du tilgang? Sjekk e-posten din for en lenke fra rekruttereren din. Finner du den ikke? Bruk alternativene nedenfor.'
        },
        loginHelp: {
            divider: 'eller',
            sendLink: {
                title: 'Mistet tilgangslenken din?',
                description: 'Vi kan sende deg en hurtigtilgangslenke for å se jobbene og kalenderen din.',
                emailLabel: 'E-post',
                emailPlaceholder: 'Skriv inn e-postadressen din',
                button: 'Send hurtigtilgangslenke',
                success: 'Sjekk e-posten din for lenken',
                errors: {
                    invalid_email: 'Vennligst skriv inn en gyldig e-postadresse',
                    candidate_not_found: 'Ingen konto funnet med denne e-postadressen',
                    send_failed: 'Kunne ikke sende e-post. Vennligst prøv igjen senere',
                    rate_limited: 'For mange forespørsler. Vennligst vent før du prøver igjen',
                    unknown: 'En feil oppstod. Vennligst prøv igjen senere'
                }
            },
            needHelp: {
                title: 'Kontakt oss',
                haveQuestion: 'Har du et spørsmål?',
                contactUs: 'Kontakt oss',
                questionLabel: 'Ditt spørsmål',
                questionPlaceholder: 'Beskriv problemet eller spørsmålet ditt',
                button: 'Send spørsmål',
                success: 'Spørsmålet ditt er sendt til supportteamet vårt',
                errors: {
                    rate_limited: 'Vennligst vent før du sender en ny forespørsel',
                    unknown: 'Kunne ikke sende. Vennligst prøv igjen'
                }
            }
        }
    },
    sv: {
        login: 'Logga in',
        logout: 'Logga ut',
        userFetchError: 'Kunde inte hämta användardata',
        tenantFetchError: 'Kunde inte hämta tillgängliga hyresgäster',
        tokenHintFetchError: 'Kunde inte initiera inloggning',
        loginError: 'Inloggning misslyckades',
        loginError_AAD_Custom_Globus_IDP_Email_Mismatch: 'Din e-postadress matchar inte den som används för ditt sociala konto. Vänligen logga in med den e-postadress som föreslagits av systemet.',
        dialog: {
            authFailed: {
                title: 'Autentisering misslyckades',
                text: 'Försök att logga in igen.',
                close: 'Stäng'
            }
        },
        signInToGetFullAccess: {
            title: 'Vänligen logga in för att fortsätta',
            description: 'Autentisera dig för att uppdatera profildetaljer, preferenser och få personliga träffar.',
            button: 'Logga in för att fortsätta',
            consent: 'Genom att fortsätta godkänner du behandlingen av dina profildata.'
        },
        signInAccessPortal: {
            title: 'Inloggning krävs',
            description: 'För att få tillgång till Karriärportalen, vänligen logga in med ditt konto.',
            button: 'Logga in',
            consent: 'Behöver du åtkomst? Kontrollera din e-post för en länk från din rekryterare. Hittar du den inte? Använd alternativen nedan.'
        },
        loginHelp: {
            divider: 'eller',
            sendLink: {
                title: 'Tappat bort din åtkomstlänk?',
                description: 'Vi kan skicka dig en snabbåtkomstlänk för att se dina jobb och kalender.',
                emailLabel: 'E-post',
                emailPlaceholder: 'Ange din e-postadress',
                button: 'Skicka snabbåtkomstlänk',
                success: 'Kontrollera din e-post för länken',
                errors: {
                    invalid_email: 'Vänligen ange en giltig e-postadress',
                    candidate_not_found: 'Inget konto hittades med denna e-postadress',
                    send_failed: 'Kunde inte skicka e-post. Vänligen försök igen senare',
                    rate_limited: 'För många förfrågningar. Vänligen vänta innan du försöker igen',
                    unknown: 'Ett fel uppstod. Vänligen försök igen senare'
                }
            },
            needHelp: {
                title: 'Kontakta oss',
                haveQuestion: 'Har du en fråga?',
                contactUs: 'Kontakta oss',
                questionLabel: 'Din fråga',
                questionPlaceholder: 'Beskriv ditt problem eller fråga',
                button: 'Skicka fråga',
                success: 'Din fråga har skickats till vårt supportteam',
                errors: {
                    rate_limited: 'Vänligen vänta innan du skickar en ny förfrågan',
                    unknown: 'Kunde inte skicka. Vänligen försök igen'
                }
            }
        }
    }
} as const;

export default authTranslations;
